import Api from "../../utils/axios";

export const multilevelApprovalApi = {
  createApproval: (payload) => Api.post("admin/create-approval-flow",payload),
  updateApproval: (payload,id) => Api.put(`admin/update-approval-flow/${id}`,payload),    
  approvalGetById: (id) => Api.get(`admin/get-approval-flow/${id}`),    
  getAllApprovals: (filter) => Api.post(`admin/get-all-approval-flow`,filter),    
  deleteApprovals: (id) => Api.get(`admin/delete-approval-flow/${id}`),    
};

export const approvalStatusApi = {
  createApprovalStatus: (payload) => Api.post("admin/create-approval-status", payload),
  updateApprovalStatus: (payload, id) => Api.put(`admin/update-approval-status/${id}`, payload),
  getApprovalStatusById: (id) => Api.get(`admin/get-approval-status/${id}`),
  getAllApprovalStatuses: (payload) => Api.post("admin/get-all-approval-status",payload),
  deleteApprovalStatus: (id) => Api.delete(`admin/delete-approval-status/${id}`),
};
